import type { WhitelabelVariantDefinition } from '../../types';

export const linkmercWhitelabel = {
  id: 'linkmerc',
  colors: {
    primary: {
      900: '#111C1F',
      800: '#172629',
      700: '#1D2F33',
      500: '#586568',
      300: '#939B9D',
      100: '#E8EAEB',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const linkmercDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: linkmercWhitelabel.colors.primary[900],
      dark: linkmercWhitelabel.colors.primary[800],
      main: linkmercWhitelabel.colors.primary[700],
      light: linkmercWhitelabel.colors.primary[500],
      lighter: linkmercWhitelabel.colors.primary[300],
      muted: linkmercWhitelabel.colors.primary[100],
      contrastText: linkmercWhitelabel.colors.primary.contrastText,
    },
  },
};
